
import Http from "../helpers/Http";

class CreditDataService {
  instance;
  baseApiUrl = process.env.VUE_APP_CREDIT_API

  constructor(){
    this.instance = Http.newInstance(this.baseApiUrl)
  }
  
  get(path){
    return Http.get(path, this.instance)
  }

  new(path, data){
    return Http.post(path,data, this.instance);
  }
  
  update(path, data){
    return Http.update(path ,data, this.instance);
  }



}

export default new CreditDataService();